var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverAssessIcon5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 47.469,
    viewBox: "0 0 53 47.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(-125.997 -77.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24034",
    "data-name": "Path 24034",
    d: "M172.836,93.129c2.846-9.269-7.848-16.688-15.5-10.976a11.056,11.056,0,0,0-8.922-4.5,11.271,11.271,0,0,0-11.2,11.288v.089A12.526,12.526,0,0,0,126,101.522c0,6.189,10.313,12.333,10.313,12.333s7.137.156,15.992.156h16.4S179,108.869,179,103.036a11.158,11.158,0,0,0-6.161-9.907Z",
    transform: "translate(0)",
    fill: "#86bc26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861",
    transform: "translate(142.541 100.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24037",
    "data-name": "Path 24037",
    d: "M118.544,157.25h-8.3s-5.808,4.977-5.808,10.785a4.672,4.672,0,0,0,4.148,4.977H120.2a4.667,4.667,0,0,0,4.148-4.977c0-5.808-5.808-10.785-5.808-10.785Z",
    transform: "translate(-104.44 -151.446)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24038",
    "data-name": "Path 24038",
    d: "M236.4,14.911h-2.293a2.5,2.5,0,0,0-3.71,0H228.1a.831.831,0,0,0-.77,1.135l.77,2.182h8.3l.77-2.182a.831.831,0,0,0-.77-1.135Z",
    transform: "translate(-222.296 -14.086)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862",
    transform: "translate(142.542 100.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24037-2",
    "data-name": "Path 24037",
    d: "M118.545,157.25h-8.3s-5.808,4.977-5.808,10.785a4.672,4.672,0,0,0,4.148,4.977H120.2a4.667,4.667,0,0,0,4.148-4.977c0-5.808-5.808-10.785-5.808-10.785Zm-3.32,11.53v1.328h-1.657v-1.324a2.229,2.229,0,0,1-2.043-2.075h1.437c.07.574.649.945,1.487.945.772,0,1.319-.375,1.319-.908,0-.454-.354-.713-1.226-.908l-.924-.2c-1.294-.27-1.93-.945-1.93-2.028a2.155,2.155,0,0,1,1.871-2.121v-1.338h1.657v1.34a2.209,2.209,0,0,1,1.9,2.043h-1.387a1.187,1.187,0,0,0-1.31-.935c-.717,0-1.235.345-1.235.886,0,.438.338.681,1.172.867l.856.182c1.428.3,2.043.908,2.043,2.018a2.216,2.216,0,0,1-2.034,2.225Z",
    transform: "translate(-104.44 -151.445)",
    fill: "#86bc26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24038-2",
    "data-name": "Path 24038",
    d: "M236.4,14.911h-2.293a2.5,2.5,0,0,0-3.71,0H228.1a.831.831,0,0,0-.77,1.135l.77,2.182h8.3l.77-2.182a.831.831,0,0,0-.77-1.135Z",
    transform: "translate(-222.296 -14.086)",
    fill: "#86bc26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverAssessIcon5);
export default __webpack_public_path__ + "static/media/discover_assess_icon_5.8833811db76848f169e260ba260fadeb.svg";
export { ForwardRef as ReactComponent };